<div class="representative-form">
    <mat-checkbox class="has-representative" color="primary" [formControl]="formGroup.controls.tieneRepresentante">
        Habilitar representante
    </mat-checkbox>
    <div class="representative-data" *ngIf="formGroup.controls.tieneRepresentante.value">
        <div class="form-line">
            <mat-form-field class="garantor-form-field nombre" appearance="outline">
                <mat-label>Nombre del representante</mat-label>
                <input matInput [formControl]="formGroup.controls.nombre">
                <mat-error *ngIf="formGroup.controls.nombre.hasError('required')">
                    Por favor ingrese un nombre
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field apellido" appearance="outline">
                <mat-label>Apellido del representante</mat-label>
                <input matInput [formControl]="formGroup.controls.apellido">
                <mat-error *ngIf="formGroup.controls.apellido.hasError('required')">
                    Por favor ingrese un apellido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-line">
            <mat-form-field class="garantor-form-field celular" appearance="outline">
                <mat-label>Teléfono del representante</mat-label>
                <app-phone-input [formControl]="formGroup.controls.celular"></app-phone-input>
                <mat-error *ngIf="formGroup.controls.celular.hasError('required')">
                    Por favor ingrese un teléfono
                </mat-error>
                <mat-hint>Ejemplo: + 54 - 911 - 11112222</mat-hint>
            </mat-form-field>
            <mat-form-field class="garantor-form-field mail" appearance="outline">
                <mat-label>E-Mail del representante</mat-label>
                <input matInput [formControl]="formGroup.controls.mail">
                <mat-error *ngIf="formGroup.controls.mail.hasError('required')">
                    Por favor ingrese el email
                </mat-error>
                <mat-error *ngIf="formGroup.controls.mail.hasError('email')">
                    Por favor ingrese un email válido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-line">
            <mat-form-field class="garantor-form-field fecha-nacimiento" appearance="outline">
                <mat-label>Fecha de nacimiento</mat-label>
                <input matInput [formControl]="formGroup.controls.fechaNacimiento" [matDatepicker]="picker1">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error *ngIf="formGroup.controls.fechaNacimiento.hasError('required')">
                    Por favor ingrese una fecha
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field dni" appearance="outline">
                <mat-label>DNI del representante</mat-label>
                <input matInput [formControl]="formGroup.controls.dni">
                <mat-error *ngIf="formGroup.controls.dni.hasError('required')">
                    Por favor ingrese el dni
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-line">
            <mat-form-field class="garantor-form-field cargo" appearance="outline">
                <mat-label>Cargo del representante</mat-label>
                <mat-select [formControl]="formGroup.controls.cargo">
                    <mat-option *ngFor="let position of positions" [value]="position.codigo" [attr.name]="position.codigo">
                        {{ position.descripcion }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formGroup.controls.cargo.hasError('required')">
                    Por favor seleccione el cargo
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field fecha-poder" appearance="outline" *ngIf="selectedPosition === 'APODERADO'">
                <mat-label>Fecha del poder</mat-label>
                <input matInput [formControl]="formGroup.controls.fechaPoder" [matDatepicker]="picker2">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <mat-error *ngIf="formGroup.controls.fechaPoder.hasError('required')">
                    Por favor ingrese una fecha
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field nombre-cargo" appearance="outline" *ngIf="selectedPosition === 'USUFRUCTUARIO_OTROS'">
                <mat-label>Nombre del cargo</mat-label>
                <input matInput [formControl]="formGroup.controls.nombreCargo">
                <mat-error *ngIf="formGroup.controls.nombreCargo.hasError('required')">
                    Por favor ingrese un nombre
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-line" *ngIf="selectedPosition === 'USUFRUCTUARIO_OTROS'">
            <mat-form-field class="garantor-form-field nro-acta" appearance="outline" *ngIf="selectedPosition === 'USUFRUCTUARIO_OTROS'">
                <mat-label>Nro acta asamblea/estatuto</mat-label>
                <input matInput [formControl]="formGroup.controls.nroAsambleaEstatuto">
                <mat-error *ngIf="formGroup.controls.nroAsambleaEstatuto.hasError('required')">
                    Por favor ingrese un número de acta
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field fecha-acta" appearance="outline" *ngIf="selectedPosition === 'USUFRUCTUARIO_OTROS'">
                <mat-label>Fecha del acta</mat-label>
                <input matInput [formControl]="formGroup.controls.fechaPoder" [matDatepicker]="picker3">
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
                <mat-error *ngIf="formGroup.controls.fechaPoder.hasError('required')">
                    Por favor ingrese una fecha
                </mat-error>
            </mat-form-field>
        </div>
        <app-file-uploader
            [formControl]="formGroup.controls.poderAdjunto"
            (documentChange)="uploadPower($event)"
            [label]="selectedPosition === 'APODERADO' ? 'Adjuntar poder' : 'Adjuntar acta/estatuto/documento'"
            requiredErrorMessage="Por favor seleccione un archivo"
        ></app-file-uploader>
        <div class="address-section">
            <span class="address-section-title">
                Dirección del representante
            </span>
            <app-address-form [formGroup]="formGroup.controls.direccion" [provinces]="provinces"></app-address-form>
        </div>
    </div>
</div>
